<template>
  <div class="page">
    <div class="record-wrapper">
      <div class="header">
        <div class="record-title">
          <font-awesome-icon icon="address-book" class="icon" />
          <p class="record-subtitle">My Team</p>
          <router-link to="/search?category=contact&query=" class="record-link">View My Team</router-link>
        </div>
      </div>
      <ul class="record">
        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="file" class="icon"/>
            <p class="record-subtitle">Diagnosis</p>
            <!-- <p class="record-explanation">Diagnosis</p> -->
            <router-link to="/currentDiagnosis" class="record-link">View Diagnosis</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="calendar-alt" class="icon"/>
            <p class="record-subtitle">Medication</p>
            <!-- <p class="record-explanation">Medication</p> -->
            <router-link to="/currentMedications" class="record-link">View Medication</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="calendar-check" class="icon"/>
            <p class="record-subtitle">Vitals</p>
            <!-- <p class="record-explanation">Vaccination</p> -->
            <router-link to="/vitalsGroup/all" class="record-link">View Vitals</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="calendar-check" class="icon"/>
            <p class="record-subtitle">Allergy</p>
            <!-- <p class="record-explanation">Allergy</p> -->
            <router-link to="/allergy" class="record-link">View Allergies</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="user-md" class="icon" />
            <p class="record-subtitle">Providers</p>
            <router-link to="/currentProviders" class="record-link">View Providers</router-link>
          </div>
        </li>
        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="user-md" class="icon" />
            <p class="record-subtitle">Nurses</p>
            <router-link to="/patientNurse" class="record-link">View Nurses</router-link>
          </div>
        </li>
        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="notes-medical" class="icon" />
            <p class="record-subtitle">Procedures</p>
            <router-link to="/currentProcedures" class="record-link">View Procedures</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="thumbtack" class="icon" />
            <p class="record-subtitle">Notes</p>
            <router-link to="/notes" class="record-link">View Notes</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon icon="prescription-bottle" class="icon" />
            <p class="record-subtitle">Orders</p>
            <router-link to="/orders" class="record-link">View Orders</router-link>
          </div>
        </li>

      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    name: "WelcomeHealthRecords"
  }
</script>

<style scoped lang="scss">
  @import "../../../stylesheets/mixins/flex";

  $color-font: #58595b;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  p {
    margin: 0;
  }
  .page {
    width: 100%;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .record-wrapper {
    max-width: 700px;
    margin: 0 auto;
    padding: 20px 30px 50px 30px;
    border: 1px solid lightgray;
    border-radius: 5px;
    text-align: center;
  }
  .header {
    text-align: center;
    color: $color-font;
    .header-icon img {
      width: 60px;
    }
    .header-title {
      font-size: 1.8em;
    }
  }
  .record {
    @include flex-box();
    @include flex-wrap(wrap);
  }
  .record-item {
    @include flex(1, 0, 45%);
    margin-top: 10px;
    width: 350px;
  }
  .record-title {
    @include flex(1, 0, 45%);
    padding: 0 20px;

    .record-subtitle {
      color: $color-font;
      padding: 5px 0;
      font-weight: bold;
    }
    .record-explanation {
      /*text-align: left;*/
      color: gray;
      font-size: 0.9em;
    }
    .record-link {
      display: block;
      width: 100%;
      background-color: #007bff;
      color: #fff;
      font-size: 0.8em;
      border-radius: 3px;
      padding: 5px 0;
      margin-top: 10px;
    }

  }
  .icon {
    font-size: 2.0em;
  }
  @media only screen and (max-width: 768px) {
    .page {
      padding: 0;
    }
    .record-wrapper {
      padding: 30px 10px;
    }
    .record-item {
      @include flex(1, 0, 100%);
      margin-top: 30px;
    }
    .header {
      .header-title {
        font-size: 1.2em;
        font-weight: bold;
      }
      .header-icon img {
        display: none;
      }
    }
  }
</style>